import BaseApi from '~/api/base';
class ProjectWorkspaceDocumentComparisons extends BaseApi {
    constructor() {
        super('/projects-workspace/document-comparisons');
    }
}
const ProjectWorkspaceDocumentComparisonsApi = new ProjectWorkspaceDocumentComparisons();
export default ProjectWorkspaceDocumentComparisonsApi;
